import AllBookings from './AllBookings';

export default AllBookings;
